<div class="drawer-host">
  <!-- Transparent clickable shade (no darkened background) -->
  <div
    #shade
    class="transparent-shade"
  ></div>

  <div class="drawer-bottom">
    <div class="outer-container">
      <h3>
        @if (displayIcon) {
          <i class="icon fa-regular fa-{{displayIcon}}"></i>
        }
        {{displayName}}
      </h3>

      <div class="tile-grid">
        @for (entry of entries; track entry.key) {
          <motn-tile
            [rawTile]="entry.tile"
          ></motn-tile>
        }
      </div>
    </div>
  </div>
</div>
